import { ClassicPreset } from 'rete';
import { StepData } from '../../models/step-data';
import { NodeEvent } from './node-event';

/**
 * Représente un noeud correspondant à une étape de workflow.
 */
export class WorkflowStepNode extends ClassicPreset.Node {
    public width = 205;
    public height = 100;

    /**
     * Indique le type du noeud.
     */
    public type = 'WorkflowStepNode';

    /**
     * Constructeur.
     * @param name : Nom de l'étape de workflow.
     * @param workflowStepData : Données de l'étape de workflow.
     * @param callBack : Callback appellé pour gérer les évènements du noeud.
     */
    constructor(
        name: string,
        public workflowStepData: StepData,
        public callBack: (id: string, data: NodeEvent) => void
    ) {
        super(name);
    }
}
